import { render, staticRenderFns } from "./FeaturedProducts.vue?vue&type=template&id=0be3fb7b&scoped=true"
import script from "./FeaturedProducts.vue?vue&type=script&lang=js"
export * from "./FeaturedProducts.vue?vue&type=script&lang=js"
import style0 from "./FeaturedProducts.vue?vue&type=style&index=0&id=0be3fb7b&prod&lang=scss"
import style1 from "./FeaturedProducts.vue?vue&type=style&index=1&id=0be3fb7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be3fb7b",
  null
  
)

export default component.exports